export { hostCommunicationManager } from './host-communication-manager';
